// @flow
import * as React from "react";
import * as ReactDOM from "react-dom";
import { TransitionGroup } from "react-transition-group";
import { Fade } from "./Animations";

const el: ?HTMLElement = document.getElementById("modal");

export const ModalContext = React.createContext({
  queue: [],
  showModal: () => {},
  hideModal: () => {},
  dismissAllModals: () => {}
});

export const ModalConsumer = ModalContext.Consumer;

type HideProps = ?{
  all?: boolean,
  callback?: () => void
};

export type ShowModal = (
  component: React.ComponentType<*>,
  props?: any
) => void;

export type HideModal = (hide: HideProps) => void;

type Props = {
  children: React.Node
};

type State = {
  queue: Array<{
    component: React.ComponentType<*>,
    props: any
  }>,
  showModal: ShowModal,
  hideModal: HideModal,
  dismissAllModals: () => void
};

export class ModalProvider extends React.Component<Props, State> {
  showModal = (component: React.ComponentType<*>, props?: any = {}) => {
    this.setState(state => ({
      queue: [
        ...state.queue,
        {
          component,
          props
        }
      ]
    }));

    // if (document.body) {
    //   document.body.style.overflow = "hidden";
    // }
  };

  hideModal = (hide: HideProps) => {
    if (hide && hide.all) {
      this.setState({
        queue: []
      });
    } else {
      this.setState(state => ({
        queue: state.queue.slice(0, -1)
      }));
    }

    // if (document.body) {
    //   document.body.style.overflow = "";
    // }

    if (hide && hide.callback != null) hide.callback();
  };

  dismissAllModals = () => {
    this.setState({
      queue: []
    });

    // if (document.body) {
    //   document.body.style.overflow = "";
    // }
  };

  state = {
    queue: [],
    showModal: this.showModal,
    hideModal: this.hideModal,
    dismissAllModals: this.dismissAllModals
  };

  render() {
    return (
      <ModalContext.Provider value={this.state}>
        {this.props.children}
      </ModalContext.Provider>
    );
  }
}

export class ModalRoot extends React.Component<{}, {}> {
  retainedModal = null;

  render() {
    const Modal = (
      <ModalConsumer>
        {({ queue, hideModal, dismissAllModals }) => (
          <TransitionGroup component={null}>
            {queue.map((modal, i) => {
              const { component: Component, props } = modal;
              const { length } = queue;

              // не показываем никакие попапы, кроме последнего
              if (length - 1 !== i) {
                return null;
              }

              return (
                <Fade key={props.id || i}>
                  {({ style }) => {
                    if (Component) {
                      this.retainedModal = (
                        <Component
                          {...props}
                          style={style}
                          onDismiss={hideModal}
                          onDismissAll={dismissAllModals}
                        />
                      );
                      return this.retainedModal;
                    }

                    if (this.retainedModal != null) {
                      return React.cloneElement(this.retainedModal, {
                        style: style
                      });
                    }

                    return null;
                  }}
                </Fade>
              );
            })}
          </TransitionGroup>
        )}
      </ModalConsumer>
    );

    return ReactDOM.createPortal(Modal, el);
  }
}

export class ModalPortal0 extends React.Component {
  ref = React.createRef();
  state = {
    modal: null,
    showModal: (component, props) => {
      this.props.context.showModal("div", { ref: this.ref, id: props.id });

      setTimeout(() => {
        this.setState({
          modal: {
            component,
            props
          }
        });
      }, 0);
    }
  };
  //
  // componentDidMount() {
  //   this.props.context.showModal("div", { ref: this.ref });
  // }

  render() {
    let modal = null;

    if (this.state.modal && this.ref.current) {
      const { component: Component, props } = this.state.modal;

      modal = ReactDOM.createPortal(
        <Component
          {...props}
          // style={style}
          onDismiss={this.props.context.hideModal}
          onDismissAll={this.props.context.dismissAllModals}
        />,
        this.ref.current
      );
    }

    return (
      <React.Fragment>
        {this.props.children(this.state)}
        {modal}
      </React.Fragment>
    );
  }
}

export let ModalPortal = props => (
  <ModalContext.Consumer>
    {context => <ModalPortal0 {...props} context={context} />}
  </ModalContext.Consumer>
);



// WEBPACK FOOTER //
// ./src/components/common/ModalProvider.js